// services/profileService.js
import { toast } from "react-toastify";
import { ApiUrl } from '../utils/ApiUrl';

export const profileService = {
    getAuthToken: () => {
        const token = localStorage.getItem('accessToken');
        if (!token) {
            toast.error('Authentication token not found. Please reconnect your wallet.');
            return null;
        }
        return token;
    },

    fetchProfile: async () => {
        try {
            const token = profileService.getAuthToken();
            if (!token) return null;

            const response = await fetch(`${ApiUrl}/users/profile`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to fetch profile');
            }

            return data.data;
        } catch (error) {
            console.error('Failed to fetch profile:', error);
            // handleWalletDisconnectWithReset()
            throw error;
            // return null;
        }
    },

    updateProfile: async (profileData, profileImage) => {
        try {
            const token = profileService.getAuthToken();
            if (!token) return null;

            let body;
            let headers = {
                Authorization: `Bearer ${token}`
            };

            if (profileImage) {
                // Use FormData for file upload
                const formData = new FormData();

                if (profileData.name?.trim()) {
                    formData.append('name', profileData.name.trim());
                }
                if (profileData.email?.trim()) {
                    formData.append('email', profileData.email.trim());
                }
                if (profileData.description?.trim()) {
                    formData.append('description', profileData.description.trim());
                }

                formData.append('profileImage', profileImage);
                body = formData;
            } else {
                // Send JSON for text-only updates
                const socialLinks = {};
                if (profileData.twitter?.trim()) {
                    socialLinks.twitter = profileData.twitter.trim();
                }
                if (profileData.instagram?.trim()) {
                    socialLinks.instagram = profileData.instagram.trim();
                }
                if (profileData.discord?.trim()) {
                    socialLinks.discord = profileData.discord.trim();
                }

                body = JSON.stringify({
                    name: profileData.name?.trim() || undefined,
                    email: profileData.email?.trim() || undefined,
                    description: profileData.description?.trim() || undefined,
                    socialLinks: Object.keys(socialLinks).length > 0 ? socialLinks : undefined
                });

                headers['Content-Type'] = 'application/json';
            }

            const response = await fetch(`${ApiUrl}/users/profile`, {
                method: 'PATCH',
                headers,
                body
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Failed to update profile');
            }

            return data.data;
        } catch (error) {
            console.error('Profile update error:', error);
            throw error;
        }
    }
};